import { UseQueryOptions } from '@tanstack/react-query';

import { VoiceContent } from 'domains/content/types';
import { CuredApiPaths } from 'models/enums';

import useQuery from '../useQuery';

import QueryKeys from './keys';

const useVoiceContentList = (
    reactQueryOptions?: UseQueryOptions<VoiceContent[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    return useQuery(QueryKeys.VOICE_CONTENT_LIST, CuredApiPaths.VOICE_CONTENT, reactQueryOptions, mergedAxiosOptions);
};

export default useVoiceContentList;
